import {
  Button,
  Form,
  Input,
  InputRef,
  Modal,
  Row,
  Space,
  Table,
  TableColumnType,
} from "antd";
import React, {useEffect, useRef, useState} from "react";
import {columns} from "./ModalResults.config";
import {glassStoreService, pharmacyStoreService} from "api";
import {exportFile} from "helper/common";
import {ListActionButton, ModalCustom} from "components/common";
import {setDetailRecord} from "redux/reducer/glassStore";
import {useAppDispatch} from "redux/hooks";
import {getDetailBillAPI} from "redux/reducer/glassKiot";
import {FilterDropdownProps} from "antd/es/table/interface";
import {SearchOutlined} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
const ModalResults = ({isShowModal, handleOk, handleCancel, idLo}) => {
  const [formData] = Form.useForm();
  const [data, setData] = useState([]);
  const billRef = useRef<any>();
  const dispatch = useAppDispatch();
  const receiptRef = useRef<any>();
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);
  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps["confirm"],
    dataIndex: any
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const getColumnSearchProps = (dataIndex: any): TableColumnType<any> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{padding: 8}} onKeyDown={e => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Tìm kiếm `}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{marginBottom: 8, display: "block"}}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{width: 90}}
          >
            Tìm kiếm
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{width: 90}}
          >
            Xóa
          </Button>
          {/* <Button
           type="link"
           size="small"
           onClick={() => {
             confirm({closeDropdown: false});
             setSearchText((selectedKeys as string[])[0]);
             setSearchedColumn(dataIndex);
           }}
         >
           Filter
         </Button> */}
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Đóng
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{color: filtered ? "#1677ff" : undefined}} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{backgroundColor: "#ffc069", padding: 0}}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  useEffect(() => {
    // columns.find(e => e.dataIndex == "action").render = (
    //   value,
    //   record,
    //   index
    // ) => {
    //   return (
    //     <ListActionButton reportFunction={exportReport}></ListActionButton>
    //   );
    // };
  }, [idLo]);
  const exportReport = () => {
    // console.log(soLo);
    exportFile(
      "store/glasses-store/export-lich-su-xn",
      {idLo: idLo},
      `Lịch sử nhập xuất lô ${idLo}`
    );
  };
  useEffect(() => {
    console.log(idLo);
    if (idLo) {
      getLichSuNhapXuatByIdLo(idLo);
    }
  }, [idLo]);
  const getDetailReceipt = async id => {
    try {
      const res = await glassStoreService.getDetailReceipt(id);
      dispatch(setDetailRecord(res));
    } catch (error) {}
  };
  const showBill = item => {
    // console.log(item);
    if (item?.loaiDon == 1) {
      billRef?.current.openModal();
      dispatch(getDetailBillAPI(item?.phieuThamChieuId));
    } else if (item?.loaiDon == 0) {
      receiptRef?.current.openModal();
      getDetailReceipt(item?.receiptId);
    }
  };
  const getLichSuNhapXuatByIdLo = async idLo => {
    try {
      let res = await pharmacyStoreService.getLichSuXuatNhapByIdLo(idLo);
      setData(res);
    } catch (error) {}
  };

  return (
    <Modal
      title="Thông tin lịch sử xuất nhập"
      centered
      open={isShowModal}
      onCancel={handleCancel}
      width={"100%"}
      className="modal-tab-pay"
      footer=""
    >
      <div style={{padding: "16px"}}>
        <Form form={formData}>
          <Table
            pagination={false}
            bordered
            dataSource={data}
            columns={columns(
              getColumnSearchProps("khoNhap"),
              getColumnSearchProps("khoXuat")
            )}
            scroll={{x: 1500}}
            showSorterTooltip={{target: "sorter-icon"}}
            // onRow={record => ({
            //   onDoubleClick: () => showBill(record),
            // })}
          />
          {/* <Form.Item>
            <Row justify={"end"} style={{padding: "16px"}}>
              <Space>
                <Button
                  key="cancel"
                  type="primary"
                  danger
                  onClick={handleCancel}
                >
                  Huỷ bỏ
                </Button>
                ,
                <Button
                  key="submit"
                  type="primary"
                  htmlType="submit"
                  onClick={handleCancel}
                >
                  Duyệt
                </Button>
              </Space>
            </Row>
          </Form.Item> */}
        </Form>
      </div>
      {/* <ModalCustom
        wrapClassName="modal-print-form"
        ref={billRef}
        width={1100}
        centered
      >
        <BillModal />
      </ModalCustom>
      <ModalCustom
        wrapClassName="modal-print-form"
        ref={receiptRef}
        width={1100}
        centered
      >
        <ReceiptModal />
      </ModalCustom> */}
    </Modal>
  );
};

export default ModalResults;
